export const PAPER_MODES = [
  {
    id: "light",
    nameZh: "纯净明亮",
    nameEn: "Light",
    isDark: false,
    previewBg: "#ffffff",
    previewText: "#1c1917",
    bgDefault: "#f8f9fa",
    bgPaper: "#ffffff",
    textPrimary: "#1c1917",
    textSecondary: "#6b7280",
    divider: "rgba(0, 0, 0, 0.08)",
  },
  {
    id: "sepia",
    nameZh: "羊皮古卷",
    nameEn: "Parchment",
    isDark: false,
    previewBg: "#fbf0d9",
    previewText: "#2c2114",
    bgDefault: "#f4ebd9",
    bgPaper: "#fbf0d9",
    textPrimary: "#2c2114",
    textSecondary: "#78654c",
    divider: "rgba(139, 105, 20, 0.12)",
  },
  {
    id: "sage",
    nameZh: "灵修茶绿",
    nameEn: "Sage Green",
    isDark: false,
    previewBg: "#edf5ed",
    previewText: "#1c2a1e",
    bgDefault: "#e3ece4",
    bgPaper: "#edf5ed",
    textPrimary: "#1c2a1e",
    textSecondary: "#526b56",
    divider: "rgba(34, 100, 45, 0.12)",
  },
  {
    id: "oat",
    nameZh: "暖阳麦香",
    nameEn: "Warm Oat",
    isDark: false,
    previewBg: "#faf4ea",
    previewText: "#2b2318",
    bgDefault: "#f2ebd9",
    bgPaper: "#faf4ea",
    textPrimary: "#2b2318",
    textSecondary: "#7a6b57",
    divider: "rgba(160, 120, 60, 0.12)",
  },
  {
    id: "taupe",
    nameZh: "豆沙粉霞",
    nameEn: "Rose Taupe",
    isDark: false,
    previewBg: "#f7f0f0",
    previewText: "#2c1e21",
    bgDefault: "#ede3e3",
    bgPaper: "#f7f0f0",
    textPrimary: "#2c1e21",
    textSecondary: "#785860",
    divider: "rgba(150, 80, 100, 0.12)",
  },
  {
    id: "slate",
    nameZh: "水墨浅灰",
    nameEn: "E-Ink Slate",
    isDark: false,
    previewBg: "#f1f3f5",
    previewText: "#212529",
    bgDefault: "#e9ecef",
    bgPaper: "#f1f3f5",
    textPrimary: "#212529",
    textSecondary: "#6c757d",
    divider: "rgba(0, 0, 0, 0.1)",
  },
  {
    id: "dark",
    nameZh: "深邃暗黑",
    nameEn: "Dark Night",
    isDark: true,
    previewBg: "#1e1e1e",
    previewText: "#f3f4f6",
    bgDefault: "#121212",
    bgPaper: "#1e1e1e",
    textPrimary: "#f3f4f6",
    textSecondary: "#9ca3af",
    divider: "rgba(255, 255, 255, 0.1)",
  },
  {
    id: "navy",
    nameZh: "午夜幽蓝",
    nameEn: "Midnight Navy",
    isDark: true,
    previewBg: "#111827",
    previewText: "#e2e8f0",
    bgDefault: "#0b1120",
    bgPaper: "#111827",
    textPrimary: "#e2e8f0",
    textSecondary: "#94a3b8",
    divider: "rgba(255, 255, 255, 0.12)",
  },
];

export const ACCENT_COLORS = [
  {
    id: "blue",
    nameZh: "经典蓝",
    nameEn: "Classic Blue",
    mainLight: "#1976d2",
    mainDark: "#60a5fa",
    dotColor: "#2563eb",
  },
  {
    id: "gold",
    nameZh: "恩典金",
    nameEn: "Grace Gold",
    mainLight: "#b45309",
    mainDark: "#fbbf24",
    dotColor: "#d97706",
  },
  {
    id: "green",
    nameZh: "灵修绿",
    nameEn: "Meadow Green",
    mainLight: "#15803d",
    mainDark: "#4ade80",
    dotColor: "#16a34a",
  },
  {
    id: "purple",
    nameZh: "圣洁紫",
    nameEn: "Sacred Purple",
    mainLight: "#7e22ce",
    mainDark: "#c084fc",
    dotColor: "#9333ea",
  },
  {
    id: "rose",
    nameZh: "救赎红",
    nameEn: "Crimson Rose",
    mainLight: "#be123c",
    mainDark: "#fb7185",
    dotColor: "#e11d48",
  },
  {
    id: "amber",
    nameZh: "琥珀橙",
    nameEn: "Warm Amber",
    mainLight: "#c2410c",
    mainDark: "#fb923c",
    dotColor: "#ea580c",
  },
  {
    id: "teal",
    nameZh: "薄荷青",
    nameEn: "Mint Teal",
    mainLight: "#0f766e",
    mainDark: "#2dd4bf",
    dotColor: "#0d9488",
  },
  {
    id: "brown",
    nameZh: "典雅棕",
    nameEn: "Classic Wood",
    mainLight: "#78350f",
    mainDark: "#d97706",
    dotColor: "#92400e",
  },
];

export const getPaperMode = (modeId) => {
  return PAPER_MODES.find((m) => m.id === modeId) || PAPER_MODES[0];
};

export const getAccentColor = (accentId) => {
  return ACCENT_COLORS.find((a) => a.id === accentId) || ACCENT_COLORS[0];
};
